<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout row wrap fill-height>
        <v-fab-transition>
          <TabReportMensile v-if="bottomNav === 'mensile'"></TabReportMensile>
        </v-fab-transition>
      </v-layout>
    </v-container>
    <v-bottom-nav :active.sync="bottomNav" class="primary" :value="true" fixed app>
      <v-btn value="mensile" class="tree--text">
        <span>Mensile</span>
        <v-badge color="purple" left overlap>
          <v-icon>perm_contact_calendar</v-icon>
        </v-badge>
      </v-btn>
    </v-bottom-nav>
    <loading :show="isLoading" :label="textLoading"></loading>
  </v-content>
</template>

<script>
import { Report } from "../stores";
import { TabReportMensile, Loading } from "../components";

export default {
  name: "p-report",
  components: {
    TabReportMensile,
    Loading
  },
  data() {
    return {
      showBadge: true,
      bottomNav: "mensile"
    };
  },
  beforeCreate() {
    if (!this.$store.hasModule("report")) {
      this.$store.registerModule("report", Report);
    }
  },
  watch: {},
  computed: {
    isLoading() {
      return this.$store.getters["report/loading"];
    },
    textLoading() {
      return this.$store.getters["report/textProcess"];
    }      
  },
  mounted() {},
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/pages/Report.vue